import { OtelExportSection } from "./OtelExportSection.js";
import { PluginMarketplaceSection } from "./PluginMarketplaceSection.js";
import { RepoSkillsList } from "./RepoSkillsList.js";

/**
 * Settings, the Agent runs card (`/settings/agent-runs`): what Wright loads
 * when it builds and where YAGNI Code sessions report. The repositories whose
 * committed skills load, the workspace's plugin marketplace, and the
 * telemetry export. A person's own skills repository is on You.
 */
export function AgentRunsView() {
  return (
    <div className="body" data-testid="settings-agent-runs">
      <RepoSkillsList />
      <PluginMarketplaceSection />
      <OtelExportSection />
    </div>
  );
}
